import { render } from "./UserItem.vue?vue&type=template&id=7048ea08&ts=true"
import script from "./UserItem.vue?vue&type=script&lang=ts"
export * from "./UserItem.vue?vue&type=script&lang=ts"

import "./UserItem.vue?vue&type=style&index=0&id=7048ea08&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__